export const environment = {
    production: false,
    apiUrl: 'https://yxadmin-dev.transnetyx.com/api',
    apiSeqUrl: 'https://sequencing-dev.transnetyx.com/api/admin',

    auth0: {
        domain: 'login-dev.transnetyx.com',
        clientId: 'dZ51sesaL6Wkhe0FXzYjLJFkcRtC7NL1',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-dev.transnetyx.com/v2/logout/order-manager`,
        logoutUrl: 'https://login-dev.transnetyx.com/v2/logout',
    },

    omAccountOverviewUrl: (userId: string) =>
        `https://ordermanager-dev.transnetyx.com/Accounts/User.aspx?UserId=${userId}`,
    omOrganizationOverviewUrl: (orgId: string) =>
        `https://ordermanager-dev.transnetyx.com/Accounts/Organization.aspx?OrganizationId=${orgId}`,
    accountSettingsUrl: (userEmail: string) =>
        `https://accounts-dev.transnetyx.com/Administration/EditUser?id=${userEmail}`,

    quickorderUrl: 'https://quickorder2-dev.transnetyx.com/',
    omUrl: 'https://ordermanager-dev.transnetyx.com/',
    omAccountsUrl: 'https://ordermanager-dev.transnetyx.com/Accounts/Default.aspx',
    omAssaysUrl: 'https://ordermanager-dev.transnetyx.com/AssayDesign/Default.aspx',
    omOrdersUrl: 'https://ordermanager-dev.transnetyx.com/Orders/Default.aspx',
    omPricingUrl: 'https://ordermanager-dev.transnetyx.com/Pricing/Default.aspx',
    omPmUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/Default.aspx',
    omSalesUrl: 'https://ordermanager-dev.transnetyx.com/Sales/Dashboard.aspx',
    omShippingUrl: 'https://ordermanager-dev.transnetyx.com/Shipping/SupplyRequests.aspx',
    omStrainsUrl: 'https://ordermanager-dev.transnetyx.com/Strains/Default.aspx',
    omTagCenterUrl: 'https://ordermanager-dev.transnetyx.com/TAG/Default.aspx',
    omBannerSettingsUrl: 'https://ordermanager-dev.transnetyx.com/Admin/Banners/Default.aspx',
    omAccountsOrganizationsUrl: 'https://ordermanager-dev.transnetyx.com/Accounts/Organizations.aspx',
    omAccountsOnlineUsersUrl: 'https://ordermanager-dev.transnetyx.com/Accounts/UsersOnline.aspx',
    omAssaysSearchUrl: 'https://ordermanager-dev.transnetyx.com/AssayDesign/Search.aspx',
    omAssaysProbesMfgUrl: 'https://ordermanager-dev.transnetyx.com/AssayDesign/ProbeManufacturing.aspx',
    omAssaysConstructsUrl: 'https://ordermanager-dev.transnetyx.com/AssayDesign/Constructs.aspx',
    omOrdersCreateUrl: 'https://ordermanager-dev.transnetyx.com/Orders/OrderCreate.aspx',
    omOrdersPendingOrdersUrl: 'https://ordermanager-dev.transnetyx.com/Orders/OrdersPending.aspx',
    omOrdersIncompleteOrdersUrl: 'https://ordermanager-dev.transnetyx.com/Orders/OrdersIncomplete.aspx',
    omOrdersWellplateStorageUrl: 'https://ordermanager-dev.transnetyx.com/Orders/WellplateStorage.aspx',
    omPricingPromoCreditsUrl: 'https://ordermanager-dev.transnetyx.com/Pricing/Discounting.aspx',
    omPricingPaymentMethodsUrl: 'https://ordermanager-dev.transnetyx.com/Pricing/PaymentMethods.aspx',
    omProbesAddPredefinedProbesUrl: 'https://ordermanager-dev.transnetyx.com/PredefinedProbes/PredefinedProbeAdd.aspx',
    omProbesABIFileImportUrl: 'https://ordermanager-dev.transnetyx.com/PredefinedProbes/AbiOrderFileImport.aspx',
    omProbesManufacturingUrl: 'https://ordermanager-dev.transnetyx.com/PredefinedProbes/Manufacturing.aspx',
    omProbesSequencingUrl: 'https://ordermanager-dev.transnetyx.com/PredefinedProbes/Sequencing.aspx',
    omPmTasksUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/Tasks.aspx',
    omPmNotesUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/Notes.aspx',
    omPmOrdersLimsUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/OrdersLims.aspx',
    omPmPendingOrdersUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/OrdersPending.aspx',
    omPmOfflineWellplatesUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/WellplatesOffline.aspx',
    omPmOfflineSequencingUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/SequencingTubesOffline.aspx',
    omPmStrainCopyUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/StrainCopy.aspx',
    omPmUnreceivedOrdersUrl: 'https://ordermanager-dev.transnetyx.com/ProjectManagement/OrdersNotReceived.aspx',
    omSalesAssayDesignUrl: 'https://ordermanager-dev.transnetyx.com/Sales/AssayDesign.aspx',
    omSalesNotesUrl: 'https://ordermanager-dev.transnetyx.com/Sales/Notes.aspx',
    omSalesProspectsUrl: 'https://ordermanager-dev.transnetyx.com/Sales/SalesProspects.aspx',
    omShippingCentralShippingUrl: 'https://ordermanager-dev.transnetyx.com/Shipping/CentralShipping.aspx',
    omShippingSequencingUrl: 'https://ordermanager-dev.transnetyx.com/Shipping/Sequencing.aspx',
    omShippingLabelSettingsUrl: 'https://ordermanager-dev.transnetyx.com/Shipping/LabelSettings.aspx',
    omOrderResultsUrl: 'https://ordermanager-dev.transnetyx.com/Orders/OrderResults.aspx',
    omManagePickupsUrl: 'https://ordermanager-dev.transnetyx.com/Shipping/ManagePickups.aspx',
    omWellplatesUrl: 'https://ordermanager-dev.transnetyx.com/Orders/OrderWellplates.aspx',

    sequencingUrl: 'https://sequencing-dev-aws.transnetyx.com/',
    sequencingRetestSetupUrl: 'https://sequencing-dev-aws.transnetyx.com/checkmate/retest',
    sequencingOrderSetupUrl: 'https://sequencing-dev-aws.transnetyx.com/orders/setup',
    sequencingGroupDetailsUrl: (userId: string) =>
        `https://sequencing-dev-aws.transnetyx.com/groups/settings/${userId}`,
    sequencingRetestSetupForOrderUrl: (groupId: string, orderId: string) =>
        `https://sequencing-dev-aws.transnetyx.com/${groupId}/checkmate/retest?orderId=${orderId}`,
};
